__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/22414412ac6b4d07af4818bb2d5eb1d2efcf5413/_next/";